import { render, staticRenderFns } from "./BarcodeScanner.vue?vue&type=template&id=60d1cbee&scoped=true&"
import script from "./BarcodeScanner.vue?vue&type=script&lang=ts&"
export * from "./BarcodeScanner.vue?vue&type=script&lang=ts&"
import style0 from "./BarcodeScanner.vue?vue&type=style&index=0&id=60d1cbee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d1cbee",
  null
  
)

export default component.exports